// utils/uhiddenUtil.js
import CryptoJS from 'crypto-js';
import VueCookies from 'vue-cookies';

export default {
  // 获取当前页面名（去除扩展名）
  getPageName() {
    // 如果将来需要页面名，可以取消注释
     const path = window.location.pathname;
    const pagename= path.substring(path.lastIndexOf('/') + 1).split('.')[0].toLowerCase();
    //console.info("path:"+path+",pagename:"+pagename);
    return pagename;
  },

  // MD5 加密
  md5(str) {
    return CryptoJS.MD5(str).toString();
  },
  // 获取或生成 CookieId
  getCurrentUnme() {
   // const key = 'currentunme';
    let val = window.sysloginume;
    //let val = "ptceshihao";
    return val;
  },
  logotCurrentUnme() {
    //const key = 'currentunme';
    //VueCookies.set(key, '', '365d');
    window.sysloginume="";
  },
  // 创建 GUID
  generateGUID() {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  },

  // 获取或生成 CookieId
  getSystemSiteCookieId() {
    const key = 'vjssitemcookieid'; 
    let val = VueCookies.get(key);
    return val;
  },
  getClientSiteCookieId() {
    const key = 'cvjssitecookieid'; 
    let val = VueCookies.get(key);
    return val;
  },
  setClientSiteCookieId() {
    var systemCookieId=this.getSystemSiteCookieId();
    const key = 'cvjssitecookieid'; 
    VueCookies.set(key, systemCookieId, '365d');
  },
  // 获取或生成 uhidden
  getSystemCookieId() {
   // const cookieId = this.getSystemSiteCookieId();
    const cookieId = window.sysmcookieid;

    const tokenKey = this.md5(cookieId + this.getPageName());
    //let uhidden = VueCookies.get(tokenKey);
     
    //if (!uhidden) {
     let uhidden = this.generateGUID();
      VueCookies.set(tokenKey, uhidden, '365d');
   // }

     //console.info("cookieId:"+cookieId+",tokenKey:"+tokenKey+",uhidden:"+uhidden+",PageName:"+this.getPageName());

    return uhidden;
  }
};



// WEBPACK FOOTER //
// ./src/utils/uhiddenUtil.js